export enum TabNames {
  PDQ_IMPACT = 'pdq-impact',
  ALL_TESTS = 'all-tests',
  TEST_RESULTS = 'test-results',
  TEST_RESULTS_CROSS_SITE = 'test-results-cross-site',
  DEEP_AB_TEST = 'deep-a-b-test-analysis',
  CHECKOUT_PERFORMANCE = 'checkout-performance',
  SHIPPING_ANALYTICS = 'shipping-analytics',
}

// Default values for QuickSight dashboard parameters
export const DASHBOARD_PARAM_DEFAULTS = {
  NO_FILTER: '--',
  CHECKOUT_AB_TEST: 'Checkout A/B Test',
} as const;

const CROSS_SITE_PARAMS = [
  'CrossSitecalculateImpactFor',
  'CrossSiteKPILiftMethod',
  'CrossSiteMainKPI',
  'CrossSiteoutliers',
  'CrossSiteSegment',
  'CrossSitetestTestName',
] as const;

const REGULAR_TEST_RESULTS_PARAMS = [
  'testName',
  'segmentparameter',
  'mainKPI',
  'levelOfStrictParameter',
  'calculateImpactFor',
  'outliersFilter',
  'DppcORGppc',
  'HideORShowImpact',
  'KPILiftMethod',
] as const;

export { CROSS_SITE_PARAMS, REGULAR_TEST_RESULTS_PARAMS };

export const TAB_PARAMETERS: Record<TabNames, readonly string[]> = {
  [TabNames.PDQ_IMPACT]: ['mainKPI', 'ImpactStatus', 'outliersFilter'],
  [TabNames.ALL_TESTS]: ['testName', 'ShowCheckoutORCrossSiteAB', 'CrossSitetestTestName'],
  [TabNames.TEST_RESULTS]: [...REGULAR_TEST_RESULTS_PARAMS, ...CROSS_SITE_PARAMS],
  [TabNames.TEST_RESULTS_CROSS_SITE]: CROSS_SITE_PARAMS,
  [TabNames.DEEP_AB_TEST]: [
    'testName',
    'KPISelection',
    'DimensionSelection1Deepabtest',
    'DimensionSelection2Deepabtest',
    'VariantFilter',
    'subtotalAfteDisMINFilter',
    'subtotalAfteDisMAXFilter',
    'outliersFilter',
    'CustomerTypeFilter',
    'HascouponcodeFilter',
    'IssubscriptionFilter',
    'FinalvsinitialcartvalueFilter',
    'ShippingmethodtitleFilter',
    'DeliveryCountryFilter',
    'IslowerUSAFilter',
    'AbandonStep',
  ],
  [TabNames.CHECKOUT_PERFORMANCE]: [
    'startDate1',
    'endDate',
    'customer',
    'DimensionSelection1CheckoutPer',
    'KPISelectionOverTimeCheckoutPer',
    'PFilterShipping',
    'subtotalAfteDisMINFilter',
    'subtotalAfteDisMAXFilter',
    'BucketSize',
  ],
  [TabNames.SHIPPING_ANALYTICS]: [
    'startDate1',
    'endDate',
    'TPX',
    'BusinessORCalendar',
    'Zone',
    'PFilterShipping',
    'DimensionSelection1Shipment',
    'KPISelection1Shipment',
  ],
} as const;
